import React, { Component } from 'react'
import classnames from 'classnames'
import app from '../../feathers'

import Entry from './Entry'

import './Blog.css';

const postsService = app.service('/posts')

class Blog extends Component {

  constructor(props) {
    super(props)

    this.state = {
      toggleSomething: false,
      posts: []
    }

    this.wowToggle = this.wowToggle.bind(this)
  }

  componentDidMount() {
    postsService.find({
      query: {
        $limit: 10,
        $sort: {
          created_at: -1
        }
      }
    })
      .then((postsData) => {
        console.log('GOT SOME DATA BRO!', postsData);
        this.setState({ posts: postsData.data })
      })
  }

  wowToggle() {
    console.log('toggling')
    this.setState({toggleSomething: !this.state.toggleSomething})
  }

  render() {

    // Super obvious, but no one does this because they're out of it:
    const { className } = this.props;

    return (
      <div className={classnames('blog', className)}>

        {/*<div onClick={this.wowToggle}>BUTTON</div>*/}
        {/*<div>{this.state.toggleSomething ? 'toggle' : 'untoggle'}</div>*/}

        {this.state.posts.map((post, i) => {
          return (
            <Entry post={post} key={i} />
          )
        })}

        <div className="pagination">
          <a ng-click="vm.getOlderPosts()">older posts</a>
          <a ng-click="vm.getNewerPosts()">newer posts</a>
        </div>
      </div>
    )

  }
}

export default Blog



// WEBPACK FOOTER //
// ./src/components/Blog/index.js